<template>
  <v-card
    class="px-4 py-6 searchFinder d-flex justify-space-between flex-column"
    min-height="280"
  >
    <v-row no-gutters class="px-md-5">
      <v-col cols="12" md="3"
        class="text-left"
        :class="data.user && data.user.handicap ? '' : 'paddingNotHandicap'"
        v-if="data.user"
      >
        <div
          class="text-center mx-auto mx-md-0 mb-5 mb-md-0"
          style="width: fit-content;"
        >
          <AvatarComponent
            size="86"
            hasBorder
            :url="data.user.picture"
          />
          <p class="primary--text text-center my-md-4 my-3">
            {{ data.user.name }}
          </p>

          <v-row no-gutters class="handicapBorder" v-if="data.user.handicap">
            <div><translate>Handicap</translate>:</div>
            <div>{{ data.user.handicap }}</div>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12" md="7" class="d-flex justify-space-between flex-column">
        <v-row no-gutters>
          <v-col cols="12" :md="6" class="mb-5">
            <label><translate>Golf course</translate> :</label>
            <ul class="pl-0">
              <li v-for="(item, idx) in data.courses" :key="idx">
                <i class="fas fa-circle fa-small fa-xs"></i>{{ item.name }}
              </li>
            </ul>
          </v-col>
          <v-col cols="12" :md="6" class="mb-5">
            <label><translate>Available on</translate> :</label>
            <ul v-if="data.timeTemporary.length == 0" class="listAvailable">
              <li v-if="data.mondayFrom">
                <i class="fas fa-circle fa-small fa-xs"></i> <translate>Monday</translate> ({{
                  data.mondayFrom
                }}
                - {{ data.mondayTo }})
              </li>
              <li v-if="data.tuesdayFrom">
                <i class="fas fa-circle fa-small fa-xs"></i> <translate>Tuesday</translate> ({{
                  data.tuesdayFrom
                }}
                - {{ data.tuesdayTo }})
              </li>
              <li v-if="data.wednesdayFrom">
                <i class="fas fa-circle fa-small fa-xs"></i> <translate>Wednesday</translate> ({{
                  data.wednesdayFrom
                }}
                - {{ data.wednesdayTo }})
              </li>
              <li v-if="data.thursdayFrom">
                <i class="fas fa-circle fa-small fa-xs"></i> <translate>Thursday</translate> ({{
                  data.thursdayFrom
                }}
                - {{ data.thursdayTo }})
              </li>
              <li v-if="data.fridayFrom">
                <i class="fas fa-circle fa-small fa-xs"></i> <translate>Friday</translate> ({{
                  data.fridayFrom
                }}
                - {{ data.fridayTo }})
              </li>
              <li v-if="data.saturdayFrom">
                <i class="fas fa-circle fa-small fa-xs"></i> <translate>Saturday</translate> ({{
                  data.saturdayFrom
                }}
                - {{ data.saturdayTo }})
              </li>
              <li v-if="data.sundayFrom">
                <i class="fas fa-circle fa-small fa-xs"></i> <translate>Sunday</translate> ({{
                  data.sundayFrom
                }}
                - {{ data.sundayTo }})
              </li>
            </ul>
            <ul v-else class="listAvailable">
              <li v-for="(day, idx) in data.timeTemporary" :key="idx">
                <i class="fas fa-circle fa-small fa-xs"></i> {{day[0]}} ({{
                  day[1]
                }}
                - {{ day[2] }})
              </li>
            </ul>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="12" :md="6" class="mb-5 mb-md-0">
          </v-col>
          <v-col cols="12" :md="6" class="mb-5 mb-md-0">
            <v-row no-gutters class="pb-2">
              <v-col cols="4">
                <span v-translate class="font-weight-bold">Country</span></v-col
              >
              <v-col cols="8">
                <span> : {{ data.country.name }}</span>
              </v-col>
            </v-row>

            <v-row no-gutters class="pb-2">
              <v-col cols="4">
                <span v-translate class="font-weight-bold">State</span></v-col
              >
              <v-col cols="8">
                <span>
                  :
                  {{ data.state.name }}</span
                >
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="4">
                <span v-translate class="font-weight-bold">City</span></v-col
              >
              <v-col cols="8">
                <span>
                  :
                  {{ data.city && data.city.name }}</span
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="2" class="d-flex align-center justify-end">
        <div class="boxedContent d-flex" style="position: relative">
          <v-btn
            class="ma-2 btn-square text-md-subtitle-2 body-2"
            outlined color="primary"
            @click="sendRequest()"
            :disabled="isSend || (data.friend === sended)"
            >
            <translate>Send a request</translate>
            <v-icon
              class="fal fa-arrow-right-long ml-3 btn-square"
              color="primary"
              size="25"
            ></v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
const defaultDate = [
  'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'
]
export default {
  props: {
    data: {},
    dateSearch: {}
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
    token() {
      return this.$store.state.auth.token;
    },
  },
  data() {
    return {
      sended: NOTIFIER_REQUEST_SEND,
      isSend: false
    };
  },
  methods: {
    async sendRequest() {
      if (!this.token) {
        const toggle = await this.$store.state.toggle.dialogConfirm.open(
          this.$gettext("Warning"),
          this.$gettext('You need to login'),
          { color: "warning" }
        );
        if (!toggle) return
        this.$router.push({name: 'login'})
      } else {
        if(this.data.friend === 'request message accepted') {
          this.$store.dispatch('chat/openChatBox', this.data.user.id)
        } else {
          let input = {
            friend: this.data.user.id,
            requestData: {
              city: this.data.city,
              dateFrom: this.dateSearch.from,
              dateTo: this.dateSearch.to,
              handicap: this.user.handicap
            }
          }
          defaultDate.forEach(date => {
            input.requestData[`${date}From`] = this.data[`${date}From`]
            input.requestData[`${date}To`] = this.data[`${date}To`]
          })
          const result = await this.$store.dispatch('chat/requestFriend', input)
          if(result.error) {
            this.$toast.alert(result.error.message)
          } else {
            this.isSend = true
          }
        }
      }
    }
  }
};
</script>
<style lang="scss">
.paddingNotHandicap {
  padding-left: 33px !important;
}
</style>
